<template>
  <div class="progress-top">
    <div class="progress-row">
      <div class="step-label">{{ label }}</div>
      <div class="step-info">
        <div class="step-count text-primary">Step {{ currentStep }} of {{ totalSteps }}</div>
      </div>
    </div>
    <div v-if="percent !== null" class="progress-track">
      <div class="progress-fill" :style="{ width: `${percent}%` }"></div>
    </div>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    label: string;
    percent?: number | null;
    currentStep: number;
    totalSteps: number;
  }>(),
  {
    label: "",
    percent: null,
  },
);
</script>

<style scoped lang="scss">
.progress-top {
  margin-bottom: 14px;
}

.progress-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  margin-bottom: 6px;
  color: #e8612f;
  .step-label {
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
  }
  .step-count{
    font-weight: 500;
  }
}

.progress-track {
  width: 100%;
  height: 6px;
  border-radius: 8px;
  background: #e5e7eb;
  overflow: hidden;
  margin-bottom: 20px;
}

.progress-fill {
  height: 100%;
  border-radius: 8px;
  background: #e8612f;
  transition: width 320ms ease;
  will-change: width;
  box-shadow: 0 0 0 rgba(232, 97, 47, 0.35);
  animation: progress-pulse 320ms ease;
}

@keyframes progress-pulse {
  0% {
    box-shadow: 0 0 0 rgba(232, 97, 47, 0.35);
  }

  100% {
    box-shadow: 0 0 12px rgba(232, 97, 47, 0.15);
  }
}
</style>
